// removed by extract-text-webpack-plugin
module.exports = {"Image":"_wGcBn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payment/Paypal/PaypalFooter/PaypalFooter.scss
// module id = 631
// module chunks = 0